import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCityList = {
  cityList: { data: null, loading: false, error: null },
};

export const cityList = createAsyncThunk('user/cityList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/city/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCityList = {
  [cityList.pending]: (state) => {
    state.cityList.loading = true;
  },
  [cityList.fulfilled]: (state, action) => {
    state.cityList.loading = false;
    state.cityList.data = action.payload;
    state.cityList.error = null;
  },
  [cityList.rejected]: (state, action) => {
    state.cityList.data = null;
    state.cityList.loading = false;
    state.cityList.error = action.payload;
  },
};
